module.exports = __webpack_public_path__ + "cf5407ffd0114fe5b3d46081efded36e.jpg";